import React from 'react';
import {
  useCalendarActionPerformedState,
  useCalendarActionsData,
} from '../../../../services/calendarActionsProvider';
import { useBlockDeleteIntervalSuccess } from '../../services/blockDeleteIntervalSuccess';
import { useToggleBlockIntervals } from '../../../../api/toggleBlockIntervals';

const ToggleBlockIntervals = ({ blocked, errorMessage, children }) => {
  const onSuccess = useBlockDeleteIntervalSuccess();

  const { blockedIntervalIds, unblockedIntervalIds } = useCalendarActionsData();

  const [, setIsPerformed] = useCalendarActionPerformedState();

  const { mutateAsync } = useToggleBlockIntervals({ onSuccess });

  const handleClick = async () => {
    setIsPerformed(true);

    await mutateAsync({
      blocked,
      intervalIds: blocked ? unblockedIntervalIds : blockedIntervalIds,
      errorMessage,
    });

    setIsPerformed(false);
  };

  return <div onClick={handleClick}>{children}</div>;
};

export default ToggleBlockIntervals;
